import styled from '@emotion/styled';
import { Button, type ButtonProps } from 'antd';

export interface WarningButtonProps extends ButtonProps {}

const StyledWarning = styled(Button)<WarningButtonProps>`
  box-shadow: 0 2px 0 rgba(0, 50, 65, 0.2);
`;

export const WarningButton: React.FC<WarningButtonProps> = (props) => (
  <StyledWarning color="gold" variant="solid" {...props} />
);
